module.exports = __webpack_public_path__ + "static/23-cb32c8a9ad949a3b87da2aceb7176a85.gif";